import { render, staticRenderFns } from "./reportPost.vue?vue&type=template&id=720171f4"
import script from "./reportPost.vue?vue&type=script&lang=js"
export * from "./reportPost.vue?vue&type=script&lang=js"
import style0 from "./reportPost.vue?vue&type=style&index=0&id=720171f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports